<form [formGroup]="formG1">

	@for( myInput of myInputs; track myInput.id ) {

		<div class="rubricLine">
	
			<triv-input 
				[fGroup]="formG1" 
				[data]="myInput"
			/>
	
			@if( !userSuscribable[myInput.id] ) {
				<span
					class="material-icons"
					style="font-size: 20px; cursor: default"
					title="Gesperrt für normale Benutzer"
				>
					lock_outline
				</span>
			}
	
		</div>

	}


</form>